import React, {useMemo} from 'react';
import { Motion, spring } from 'react-motion';
import './ClusterMarker.css';

export default function ClusterMarker({
  text = '0',
  lat,
  lng,
  zoom,
  setMapProps,
  isSelected,
  onPage,
  initialScale = 0.6,
  defaultScale = 1,
  hoveredScale = 1.15,
  hovered = false,
  stiffness = 320,
  damping = 7,
  precision = 0.001,
  $prerender,
}) {
  const handleClick = () => {
    if (zoom < 14) {
      setMapProps({ center: { lat, lng }, zoom: zoom + 1 });
    }
  };

  const classNames = ['cluster-marker'];
  if (onPage) classNames.push('cluster-page');
  if (isSelected) classNames.push('cluster-selected');

  const defaultMotionStyle = useMemo(
    () => ({ scale: $prerender ? defaultScale : initialScale }),
    [initialScale, defaultScale, $prerender]
  );

  const motionStyle = useMemo(
    () => ({
      scale: spring(hovered ? hoveredScale : defaultScale, {
        stiffness,
        damping,
        precision,
      }),
    }),
    [hovered, hoveredScale, defaultScale, stiffness, damping, precision]
  );

  return (
    <Motion defaultStyle={defaultMotionStyle} style={motionStyle}>
      {({ scale }) => (
        <div
          className={classNames.join(' ')}
          style={{ transform: `translate3D(0,0,0) scale(${scale}, ${scale})` }}
          onClick={handleClick}
        >
          <div>{text}</div>
        </div>
      )}
    </Motion>
  );
}